import React, { Component } from 'react';
import ItemForm1 from '../../components/despatch/GSTInvoiceFinishGoods/ItemForm1.js';
import ItemTable from '../../components/despatch/GSTInvoiceFinishGoods/ItemTable.js';
import HSNCodeTable from '../../components/despatch/GSTInvoiceFinishGoods/HSNCodeTable.js';
import PaymentSummary from '../../components/despatch/GSTInvoiceFinishGoods/PaymentSummary.js';
import ItemForm2 from '../../components/despatch/GSTInvoiceFinishGoods/itemForm2.js';
import PartyMainSearchTable from '../../components/despatch/GSTInvoiceFinishGoods/PartyMainSearchTable.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages.js';
import ItemDetailsModel from '../../components/despatch/GSTInvoiceFinishGoods/itemDetailsModel.js';
import DespatchServices from '../../services/axioServices/apiServices/DespatchServices.js';
import moment from 'moment';
import { encryptionAPI } from '../../utils/Encryption.js';
import { APIURL } from '../../utils/AppSetting.js';
import { GenerateGSTInvoiceForFinishGoodsById } from '../../services/axioServices/ApiEndPoints.js';
import { getAuthProps } from '../../utils/AuthenticationLibrary.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

class GSTInvoiceFinishGoods extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.despatchServices = new DespatchServices();
        this.state = {
            page: 'InvoiceFinishGoods',
            isEditing: false,
            isLoading: "",
            tableStatus: "",
            isGridView: true,
            isHideAddItem: false,
            setItemDetailsModel: false,
            index: null,
            partyDropdownList: [],
            transportCourierList: [],
            companyItemList: [],
            itemListing: [],
            hsnCodeList: [],
            hsnCodeListForTable: [],
            productionStockList: [],
            validationTextForStock: null,
            filterDetails: {
                invoiceNo: "",
                arrangedBy: "",
            },
            invoiceDetails: {
                gstInvoiceFinishGoodsId: "",
                invoiceNo: "",
                invoiceDate: "",
                creditDay: "",
                orderNo: "",
                partyId: "",
                transportName: "",
                transportId: "",
                lRNo: "",
                lRDate: "",
                ewbNo: "",
                cases: "",
                weight: 0,
                freight: 0,
                other: 0,
                roundOff: 0,
                invoiceNarration: "",
                subTotal: 0,
                discount: 0,
                sgst: 0,
                cgst: 0,
                igst: 0,
                ugst: 0,
                crDrNote: 0,
                grandTotal: 0,
                pendingAmount: 0,
                state: "",
                changeShippedAdd: false,
                addressLine1: "",
                addressLine2: "",
                addressLine3: "",
                addressLine4: "",
            },
            itemDetails: {
                itemId: '',
                itemName: '',
                packing: '',
                isNonInventory: false,
                batchNo: '',
                mfgDate: '',
                expDate: '',
                mrp: 0,
                qty: 0,
                stockTotalqty: 0,
                free: 0,
                rate: 0,
                amount: 0,
                discRate: 0,
                discAmount: 0,
                taxableAmount: 0,
                hsnCodeId: '',
                hsnCodeName: '',
                sgst: 0,
                cgst: 0,
                igst: 0,
                ugst: 0,
                batchClearingEntryId: null,
                stockId: null,
                make: ''
            },
            arrangedByList: [
                { arrangedBy: "Invoice No.", value: "invoiceNo" },
                { arrangedBy: "Invoice Date", value: "invoiceDate" },
                { arrangedBy: "Party Name", value: "partyName" },
                { arrangedBy: "Net Amount", value: "netAmount" },
                { arrangedBy: "transport Name", value: "transportName" },
                { arrangedBy: "LR No", value: "LRNo" },
                { arrangedBy: "LR Date", value: "LRDate" },
            ],
            validationRules: {
                itemId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item name"
                        ),
                    },
                ],
                rate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "rate"
                        ),
                    },
                ],
                hsnCodeId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "hsn Code"
                        ),
                    },
                ],

            },
            qtyValidationRule: [
                {
                    type: "require",
                    message: CommonValidationMessages.FieldRequired.replace(
                        "{0}",
                        "quantity"
                    ),
                },
            ],
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForPartyDetails: {
                partyId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "party name"
                        ),
                    },
                ],
                transportId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "tranporter"
                        ),
                    },
                ],
            },
            validStateForPartyDetails: {
                isValid: true,
                error: {},
            },
        };

    }

    componentDidMount() {
        this.getAllGSTInvoiceFinishGoodsRecords();
        document.body.classList.add("itemDetailsModel");
    }

    componentWillUnmount() {
        document.body.classList.remove("itemDetailsModel");
    }

    getAllGSTInvoiceFinishGoodsRecords = () => {
        this.setState({ tableStatus: "Loading..." })
        let request = this.state.filterDetails
        this.despatchServices.getAllGSTInvoiceFinishGoodsRecords(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                if (response.responseData.length === 0) {
                    this.setState({ tableStatus: "No Record Found" })
                } else {
                    this.setState({ tableStatus: "" })
                }
                this.setState({ gstInvoiceFinishGoodsList: response.responseData }, () => {
                    this.getAllPartyDropdown()
                })
            } else {
                this.setState({ tableStatus: "" })
                this.getAllPartyDropdown();
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                    email: item.email,
                    transporterName: item.transporterName,
                    state: item.state,
                    address1: item.address1,
                    address2: item.address2,
                    address3: item.address3,
                    address4: item.address4
                }));
                this.setState({ partyDropdownList: dropdownItems }, () => {
                    this.getAllTransportCourier();
                });
            } else {
                this.getAllTransportCourier();
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    getAllTransportCourier = () => {
        this.commonServices.getAllTransportCourier("").then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let dropdownItems = response.responseData.map((item) => ({
                    label: item.transportName,
                    value: item._id,
                }));
                this.setState({ transportCourierList: dropdownItems }, () => {
                    this.getAllItem()
                });
            } else {
                this.getAllItem()
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getAllItem = () => {
        this.commonServices.getAllItem().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.ItemName,
                    value: item._id,
                    packing: item.Packing,
                    uom: item.UOM,
                    isNonInventory: item.NonInventoryItem,
                }));
                this.setState({ companyItemList: dropdownItems }, () => {
                    this.getAllHSNCode()
                });
            } else {
                this.getAllHSNCode()
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    getAllHSNCode = () => {
        this.commonServices.getAllHSNCode().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.HSNCode,
                    value: item._id,
                    sgstRate: item.SGST,
                    cgstRate: item.CGST,
                    igstRate: item.IGST,
                    utgstRate: item.UTGST
                }));
                this.setState({ hsnCodeList: dropdownItems });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    closeGridView = () => {
        this.setState({ isGridView: false });
    };

    openGridView = () => {
        this.resetForm();
        this.setState({ isGridView: true, isEditing: false });
    };

    resetForm = () => {
        let validStateForPartyDetails = this.state.validStateForPartyDetails;
        validStateForPartyDetails.isValid = true;
        validStateForPartyDetails.error = {};
        let Fdetails = this.state.filterDetails;
        Fdetails.invoiceNo = "";
        Fdetails.arrangedBy = "";

        let Idetails = this.state.invoiceDetails;
        Idetails.gstInvoiceFinishGoodsId = "";
        Idetails.invoiceNo = "";
        Idetails.invoiceDate = "";
        Idetails.creditDay = "";
        Idetails.orderNo = "";
        Idetails.partyId = "";
        Idetails.transportName = "";
        Idetails.transportId = "";
        Idetails.subTotal = "";
        Idetails.discount = "";
        Idetails.sgst = "";
        Idetails.cgst = "";
        Idetails.igst = "";
        Idetails.ugst = "";
        Idetails.crDrNote = "";
        Idetails.grandTotal = "";
        Idetails.pendingAmount = ""
        Idetails.lRNo = ""
        Idetails.lRDate = ""
        Idetails.cases = "";
        Idetails.ewbNo = "";
        Idetails.weight = "";
        Idetails.freight = "";
        Idetails.other = "";
        Idetails.roundOff = "";
        Idetails.invoiceNarration = "";
        Idetails.addressLine1 = "";
        Idetails.addressLine2 = "";
        Idetails.addressLine3 = "";
        Idetails.addressLine4 = "";
        Idetails.changeShippedAdd = false;

        this.setState({
            invoiceDetails: Idetails,
            filterDetails: Fdetails,
            validStateForPartyDetails: validStateForPartyDetails,
            noItemFound: "",
        }, () => {
            this.getAllGSTInvoiceFinishGoodsRecords()
        });
    };

    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = value.toUpperCase();
            this.setState({ filterDetails: details }, () => {
                this.getAllGSTInvoiceFinishGoodsRecords()
            });
        } else if (section === "invoiceDetails") {
            let details = this.state.invoiceDetails;
            details[name] = value.toUpperCase();
            if (name === 'freight' || name === 'other' || name === 'roundOff') {
                this.calculateGrandTotal()
            }
            this.setState({ invoiceDetails: details });
        }
    };

    handleChangeCheckBox = (event, name) => {
        let value = event.target.checked
        let details = this.state.invoiceDetails
        details.changeShippedAdd = value
        if (value === true && details.partyId) {
            this.commonServices.getPartyCorrspAddressById(details.partyId).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    let res = response.responseData
                    let idetails = this.state.invoiceDetails
                    idetails.addressLine1 = res.corrspAddress1 + '\n' + res.corrspAddress2 + '\n' + res.corrspAddress3 + '\n' + res.corrspAddress4
                    this.setState({ invoiceDetails: idetails })
                } else {
                    this.SwalServices.Error(response.Message);
                }
            });
        }
        this.setState({ invoiceDetails: details })
    };

    setFilterParameters = (selected, drpIdentity, section) => {
        let details = this.state.invoiceDetails;
        if (drpIdentity === 'partyId') {
            details[drpIdentity] = selected.value;
            details.transportName = selected.transporterName
            details.transportId = selected.transporterName ? this.state.transportCourierList.find(tran => tran.label.toLowerCase() === selected.transporterName.toLowerCase())?.value : ''
            details.state = selected.state
            // details.addressLine1 = selected.address1
            // details.addressLine2 = selected.address2
            // details.addressLine3 = selected.address3
            // details.addressLine4 = selected.address4
        }
        if (drpIdentity === 'transportName') {
            details.transportName = selected.label
            details.transportId = selected.value
        }
        this.setState({ invoiceDetails: details });
    };

    handleDropDownChange = (event, name) => {
        const select = event.target.value;
        let details = this.state.filterDetails;
        details[name] = select;
        this.setState({ filterDetails: details }, () => {
            this.getAllGSTInvoiceFinishGoodsRecords()
        });

    };

    handleChangeForItemTable = (event, fieldName) => {
        let value = event.target.value
        let details = this.state.itemDetails;
        details[fieldName] = value;
        if (fieldName === 'rate' || fieldName === 'qty' || fieldName === 'discRate' || fieldName === 'free') {
            details.amount = (Number(details.isNonInventory === true ? 1 : details.qty) * Number(details.rate)).toFixed(2)
            details.discAmount = (Number(details.discRate) * Number(details.amount)) / 100
            details.taxableAmount = (((Number(details.isNonInventory === true ? 1 : details.qty) + Number(details.free)) * Number(details.rate)) - details.discAmount).toFixed(2)
        }
        this.setState({ itemDetails: details });
    };

    setFilterParametersForItemTable = (selected, fieldName) => {
        let details = this.state.itemDetails;
        details[fieldName] = selected.value;
        if (fieldName === 'itemId') {
            details.packing = selected.packing
            details.itemName = selected.label
            details.isNonInventory = selected.isNonInventory ? selected.isNonInventory : false
            if (selected.isNonInventory === true) {

            } else {
                this.getProductionStockByProductId(selected.value)
            }
        }
        if (fieldName === 'hsnCodeId') {
            details.hsnCodeName = selected.label
            details.sgst = selected.sgstRate
            details.cgst = selected.cgstRate
            details.igst = selected.igstRate
            details.ugst = selected.utgstRate
        }
        this.setState({ itemDetails: details });
    };

    openPopUpForAddingItem = () => {
        this.resetItemDetailsForm()
        this.setState({ setItemDetailsModel: true })
    };

    getProductionStockByProductId = (id) => {
        this.despatchServices.getProductionStockByProductId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let resList = response.responseData
                let itemListing = this.state.itemListing

                // resList = resList.map(resItem => {
                //     let matches = itemListing.filter(item => (!item._id) && (item.batchClearingEntryId === resItem.batchClearingEntryId) && (item.batchNo === (resItem.productDetialsId ? resItem.productDetialsId.batchNo : resItem.batchNo)));
                //     if (matches.length > 0) {
                //         // let totalQty = matches.reduce((sum, item) => sum + Number(item.qty), 0);
                //         // let totalFreeQty = matches.reduce((sum, item) => sum + Number(item.free), 0);
                //         let totalReduceQty = 0
                //         resItem.quantity -= totalReduceQty;
                //     }
                //     return resItem;
                // });
                resList = resList.filter(resItem => resItem.quantity > 0)

                if (this.state.isEditing === true) {
                    let item = response.responseData.find(x => x.batchClearingEntryId === this.state.itemDetails.batchClearingEntryId)
                    if (item) {
                        let details = this.state.itemDetails
                        details.stockTotalqty = item.quantity + details.free + details.qty
                        details.stockId = item._id
                        this.setState({ itemDetails: details, productionStockList: [] })
                    }
                }
                if (resList.length > 0 || this.state.isEditing === true) {
                    this.setState({ validationTextForStock: '' })
                    if (this.state.isEditing === true) {
                        this.setState({ productionStockList: [] })
                    } else {
                        this.setState({ productionStockList: resList })
                    }
                } else {
                    this.setState({ productionStockList: [], validationTextForStock: `Sorry, No Stock available for ${this.state.itemDetails.itemName ? this.state.itemDetails.itemName : 'this product'}.` })
                }
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    showHSNCodes = (fromDelete) => {
        const { itemListing, hsnCodeList } = this.state;

        const hsnCodeSummary = itemListing.reduce((acc, item) => {
            if (!acc[item.hsnCodeId]) {
                acc[item.hsnCodeId] = { hsnCodeId: item.hsnCodeId, taxableAmount: 0, amount: 0 };
            }
            acc[item.hsnCodeId].taxableAmount += Number(item.taxableAmount);
            acc[item.hsnCodeId].amount += Number(item.amount);
            return acc;
        }, {});

        const summarizedList = Object.values(hsnCodeSummary);

        const hsnCodeListForTable = summarizedList.map(summary => {
            let hsnDetails = hsnCodeList.find(hsn => hsn.value === summary.hsnCodeId) || {};

            hsnDetails.igstRate = this.state.invoiceDetails.state !== 'GUJARAT' ? hsnDetails.igstRate : 0
            hsnDetails.sgstRate = this.state.invoiceDetails.state === 'GUJARAT' ? hsnDetails.sgstRate : 0
            hsnDetails.cgstRate = this.state.invoiceDetails.state === 'GUJARAT' ? hsnDetails.cgstRate : 0
            const sgstAmount = (Number(summary.taxableAmount) * ((hsnDetails.sgstRate || 0) / 100 || 0)).toFixed(2);
            const cgstAmount = (Number(summary.taxableAmount) * ((hsnDetails.cgstRate || 0) / 100 || 0)).toFixed(2);
            const igstAmount = (Number(summary.taxableAmount) * ((hsnDetails.igstRate || 0) / 100 || 0)).toFixed(2);
            // const utgstAmount = (summary.taxableAmount * (hsnDetails.utgstRate / 100 || 0)).toFixed(2);
            const utgstAmount = 0
            const totalAmount = summary.taxableAmount + sgstAmount + cgstAmount + igstAmount + utgstAmount;

            return {
                ...hsnDetails,
                ...summary,
                sgstAmount,
                cgstAmount,
                igstAmount,
                utgstAmount,
                totalAmount
            };
        });
        this.setState({ hsnCodeListForTable }, () => {
            this.calculateGrandTotal(fromDelete)
        });
    }

    calculateGrandTotal = (fromDelete) => {
        let list = this.state.hsnCodeListForTable

        const totals = list.reduce(
            (acc, item) => {
                acc.sgstAmount += Number(item.sgstAmount) || 0;
                acc.cgstAmount += Number(item.cgstAmount) || 0;
                acc.igstAmount += Number(item.igstAmount) || 0;
                acc.utgstAmount += Number(item.utgstAmount) || 0;
                acc.taxableAmount += Number(item.taxableAmount) || 0;
                acc.amount += Number(item.amount) || 0;
                return acc;
            },
            { sgstAmount: 0, cgstAmount: 0, igstAmount: 0, utgstAmount: 0, taxableAmount: 0, amount: 0 }
        );

        let itemListing = this.state.itemListing
        let totaldisAmount = itemListing.reduce((sum, item) => sum + Number(item.discAmount), 0);

        let details = this.state.invoiceDetails
        details.subTotal = Number(totals.amount).toFixed(2)
        details.discount = Number(totaldisAmount).toFixed(2)
        details.sgst = Number(totals.sgstAmount).toFixed(2)
        details.cgst = Number(totals.cgstAmount).toFixed(2)
        details.igst = Number(totals.igstAmount).toFixed(2)
        // details.ugst = Number(totals.utgstAmount).toFixed(2)
        details.crDrNote = 0
        details.grandTotal = (Number(details.subTotal) + Number(details.sgst) + Number(details.igst) + Number(details.cgst) + - Number(details.discount)).toFixed(2)
        details.grandTotal = Number(details.grandTotal) + (Number(details.freight) || 0) + (Number(details.other) || 0)
        details.roundOff = (details.grandTotal % 1).toFixed(2);
        details.grandTotal = Math.round(details.grandTotal).toFixed(2);
        details.pendingAmount = Math.round(details.grandTotal)

        this.setState({ invoiceDetails: details }, () => {
            if (fromDelete === 'FromDelete') {
                this.addEditGSTInvoiceFinishGoods(fromDelete)
            }
        })
    }

    setOpenModel = () => {
        this.setState({ setItemDetailsModel: !this.state.setItemDetailsModel });
    };

    selectQtyFromStock = (item) => {
        let details = this.state.itemDetails
        details.batchNo = item.batchNo
        details.mfgDate = item.mfgDate ? moment(item.mfgDate).format("yyyy-MM-DD") : ''
        details.expDate = item.expDate ? moment(item.expDate).format("yyyy-MM-DD") : ''
        details.mrp = item.mrp
        details.qty = item.quantity
        details.uom = this.state.companyItemList.find(x => x.value === item.productId._id).uom
        details.stockTotalqty = item.quantity
        details.batchClearingEntryId = item.batchClearingEntryId
        details.stockId = item._id
        this.setState({ itemDetails: details }, () => {
            this.setState({ productionStockList: [] })
        })
    }

    validateStockQty = () => {
        let details = this.state.itemDetails
        let combineQty = Number(details.qty) + Number(details.free)
        if (details.isNonInventory === true) {
        } else {
            if (combineQty > details.stockTotalqty) {
                this.SwalServices.Alert(`Sorry, Stock not Sufficient. Stock is ${(details.stockTotalqty).toFixed(2)}`)
            }
        }
    }

    addItemToItemArray = () => {
        let isValidAllFields = this.isValidAllFields();
        let details = this.state.itemDetails
        let combineQty = Number(details.qty) + Number(details.free)
        if (details.isNonInventory || combineQty <= details.stockTotalqty) {
            if (isValidAllFields) {
                let itemListing = [...this.state.itemListing];
                let details = { ...this.state.itemDetails }
                if (this.state.index >= 0 && this.state.index !== null && this.state.index !== undefined) {
                    itemListing[this.state.index] = details
                } else {
                    itemListing.push(details);
                }
                this.setState({ itemListing: itemListing, setItemDetailsModel: false, isEditing: false }, () => {
                    this.showHSNCodes()
                })
            }
        } else {
            this.SwalServices.Alert(`Sorry, Stock not Sufficient. Stock is ${(details.stockTotalqty).toFixed(2)}`)
        }
    }

    isValidAllFields = () => {
        let valRule = { ...this.state.validationRules }
        if (this.state.itemDetails.isNonInventory === false || this.state.itemDetails.isNonInventory === undefined) {
            valRule.qty = this.state.qtyValidationRule
        } else {
            valRule.qty = []
        }

        const newValidState = isValidForm(
            this.state.itemDetails,
            valRule,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    resetItemDetailsForm = () => {
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        let details = this.state.itemDetails
        details.itemId = ''
        details.itemName = ''
        details.packing = ''
        details.batchNo = ''
        details.mfgDate = ''
        details.expDate = ''
        details.mrp = 0
        details.qty = 0
        details.stockTotalqty = 0
        details.free = 0
        details.rate = 0
        details.amount = 0
        details.discRate = 0
        details.discAmount = 0
        details.taxableAmount = 0
        details.hsnCodeId = ''
        details.hsnCodeName = ''
        details.sgst = 0
        details.cgst = 0
        details.igst = 0
        details.ugst = 0
        details.make = ""
        details.batchClearingEntryId = null
        this.setState({ itemDetails: details, productionStockList: [], validationTextForStock: null, validState: validState });
    }

    closePopUp = () => {
        this.setState({ setItemDetailsModel: false, isEditing: false });
    }

    editItemDetails = (index) => {
        let list = this.state.itemListing
        let itemDetails = this.state.itemDetails
        let item = list[index];
        itemDetails.itemId = item.itemId
        itemDetails._id = item._id
        itemDetails.itemName = item.itemName
        itemDetails.isNonInventory = item.isNonInventory
        itemDetails.packing = item.packing
        itemDetails.batchNo = item.batchNo
        itemDetails.mfgDate = item.mfgDate ? moment(item.mfgDate).format('yyyy-MM-DD') : ''
        itemDetails.expDate = item.expDate ? moment(item.expDate).format('yyyy-MM-DD') : ''
        itemDetails.mrp = item.mrp
        itemDetails.qty = item.qty
        itemDetails.free = item.free
        itemDetails.rate = item.rate
        itemDetails.amount = item.amount
        itemDetails.discRate = item.discRate
        itemDetails.discAmount = item.discAmount
        itemDetails.taxableAmount = item.taxableAmount
        itemDetails.hsnCodeId = item.hsnCodeId
        itemDetails.hsnCodeName = item.hsnCodeName
        itemDetails.sgst = item.sgst
        itemDetails.cgst = item.cgst
        itemDetails.igst = item.igst
        itemDetails.ugst = item.ugst
        itemDetails.batchClearingEntryId = item.batchClearingEntryId
        let selected = {
            value: item.itemId,
            packing: item.packing,
            label: item.itemName
        }
        this.setFilterParametersForItemTable(selected, 'itemId')
        this.setState({ itemDetails: itemDetails, index: index }, () => {
            this.setState({ setItemDetailsModel: true, isEditing: true })
        })
    }

    deleteItemById = (index) => {
        let list = [...this.state.itemListing];
        list.splice(index, 1);
        this.setState({ itemListing: list }, () => {
            this.showHSNCodes()
        });
    }

    isValidAllFieldsForpartyDetails = () => {
        const newValidState = isValidForm(
            this.state.invoiceDetails,
            this.state.validationRulesForPartyDetails,
            this.state.validStateForPartyDetails
        );
        this.setState({ validStateForPartyDetails: newValidState });
        return newValidState.isValid;
    };

    getGSTInvoiceFinishGoodsInvoiceNo = () => {
        this.despatchServices.getGSTInvoiceFinishGoodsInvoiceNo().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let details = this.state.invoiceDetails
                details.invoiceNo = response.responseData.invoiceNo
                details.gstInvoiceFinishGoodsId = ''
                details.invoiceDate = moment(new Date()).format('yyyy-MM-DD')
                this.setState({ invoiceDetails: details }, () => {
                    this.setState({ hsnCodeListForTable: [], itemListing: [] })
                    this.closeGridView()
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    addEditGSTInvoiceFinishGoods = (fromDelete) => {
        let isValidAllFieldsForpartyDetails = this.isValidAllFieldsForpartyDetails()
        if (isValidAllFieldsForpartyDetails) {
            if (this.state.itemListing.length > 0 || fromDelete === 'FromDelete') {
                if (fromDelete !== 'FromDelete') {
                    this.setState({ isLoading: "save" })
                }
                let request = {
                    invoiceDetails: this.state.invoiceDetails,
                    itemListing: this.state.itemListing
                }
                this.despatchServices.addEditGSTInvoiceFinishGoods(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        if (fromDelete !== 'FromDelete') {

                            this.SwalServices.Confirm(
                                "",
                                ``,
                                CommonSuccessMessages.Yes_Text,
                                CommonSuccessMessages.No_Text,
                                `Do you want to print Invoice ?`
                            ).then((res) => {
                                // if (res === true) {
                                //     let id = response.responseData.invoiceDetails._id
                                //     let encryptId = encryptionAPI(id, 0)
                                //     window.open(APIURL + GenerateGSTInvoiceForFinishGoodsById + '?id=' + encryptId, '_blank');
                                //     this.openGridView()
                                // } else {
                                //     this.openGridView()
                                // }
                                if (res === true) {
                                    this.SwalServices.Confirm(
                                        "",
                                        ``,
                                        CommonSuccessMessages.Yes_Text,
                                        CommonSuccessMessages.No_Text,
                                        `Do you want to print delivery challan ?`
                                    ).then((resp) => {
                                        let loginUser = getAuthProps();
                                        let headers = {
                                            Authorization: `Bearer ${loginUser.token}`,
                                            dbYear: loginUser.dbYear
                                        };
                                        if (resp === true) {
                                            let id = response.responseData.invoiceDetails._id
                                            let encryptId = encryptionAPI(id, 0)
                                            let deliveryChallan = encryptionAPI(true, 0)
                                            // window.open(APIURL + GenerateGSTInvoiceForFinishGoodsById + '?id=' + encryptId + '&id1=' + deliveryChallan, '_blank');
                                            fetch(`${APIURL + GenerateGSTInvoiceForFinishGoodsById}?id=${encryptId}&id1=${deliveryChallan}`, {
                                                method: 'GET',
                                                headers: headers
                                            })
                                                .then(response => response.blob())
                                                .then(blob => {
                                                    const url = window.URL.createObjectURL(blob);
                                                    const link = document.createElement('a');
                                                    link.href = url;
                                                    link.target = '_blank';
                                                    link.click();
                                                    this.setState({ isLoading: "" })
                                                    this.openGridView()
                                                })
                                        } else {
                                            let id = response.responseData.invoiceDetails._id
                                            let encryptId = encryptionAPI(id, 0)
                                            let deliveryChallan = encryptionAPI(false, 0)
                                            // window.open(APIURL + GenerateGSTInvoiceForFinishGoodsById + '?id=' + encryptId + '&id1=' + deliveryChallan, '_blank');
                                            fetch(`${APIURL + GenerateGSTInvoiceForFinishGoodsById}?id=${encryptId}&id1=${deliveryChallan}`, {
                                                method: 'GET',
                                                headers: headers
                                            })
                                                .then(response => response.blob())
                                                .then(blob => {
                                                    const url = window.URL.createObjectURL(blob);
                                                    const link = document.createElement('a');
                                                    link.href = url;
                                                    link.target = '_blank';
                                                    link.click();
                                                    this.setState({ isLoading: "" })
                                                    this.openGridView()
                                                })
                                        }
                                    });
                                } else {
                                    this.setState({ isLoading: "" })
                                    this.openGridView()
                                }
                            });
                        }
                    } else {
                        this.setState({ isLoading: "" })
                        this.SwalServices.Error(response.Message);
                    }
                });


            } else {

                this.SwalServices.Alert('No records found. Please add an item to proceed.')
            }

        }
    }

    getGSTInvoiceFinishGoodsById = (id, fromDelete) => {
        this.despatchServices.getGSTInvoiceFinishGoodsById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData
                let details = this.state.invoiceDetails
                details.gstInvoiceFinishGoodsId = res.invoiceDetails._id
                details.invoiceNo = res.invoiceDetails.invoiceNo
                details.invoiceDate = res.invoiceDetails.invoiceDate ? moment(res.invoiceDetails.invoiceDate).format('yyyy-MM-DD') : ''
                details.creditDay = res.invoiceDetails.creditDay
                details.orderNo = res.invoiceDetails.orderNo
                details.partyId = res.invoiceDetails.partyId._id
                details.state = res.invoiceDetails.partyId.state
                details.transportName = res.invoiceDetails.transportName
                details.transportId = res.invoiceDetails?.transportId?._id
                details.lRNo = res.invoiceDetails.lRNo
                details.lRDate = res.invoiceDetails.lRDate
                details.ewbNo = res.invoiceDetails.ewbNo
                details.cases = res.invoiceDetails.cases
                details.weight = res.invoiceDetails.weight
                details.freight = res.invoiceDetails.freight
                details.other = res.invoiceDetails.other
                details.roundOff = res.invoiceDetails.roundOff
                details.invoiceNarration = res.invoiceDetails.invoiceNarration
                details.subTotal = res.invoiceDetails.subTotal
                details.discount = res.invoiceDetails.discount
                details.sgst = res.invoiceDetails.sgst
                details.cgst = res.invoiceDetails.cgst
                details.igst = res.invoiceDetails.igst
                details.ugst = res.invoiceDetails.ugst
                details.crDrNote = res.invoiceDetails.crDrNote
                details.grandTotal = (res.invoiceDetails.grandTotal && Number(res.invoiceDetails.grandTotal) > 0) ? res.invoiceDetails.grandTotal : 0
                details.pendingAmount = res.invoiceDetails.pendingAmount
                details.addressLine1 = res.invoiceDetails.addressLine1
                // details.addressLine2 = res.invoiceDetails.addressLine2
                // details.addressLine3 = res.invoiceDetails.addressLine3
                // details.addressLine4 = res.invoiceDetails.addressLine4
                details.changeShippedAdd = res.invoiceDetails.changeShippedAdd

                let list = res.itemListing
                list.map(item => {
                    item.isFromDB = true
                    return item
                })
                this.setState({ invoiceDetails: details, itemListing: list }, () => {
                    this.showHSNCodes(fromDelete)
                    this.setState({ isGridView: false })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    deleteItemFromDBById = (item) => {
        let request = {
            stockId: item.stockId,
            batchClearingEntryId: item.batchClearingEntryId,
            gstInvoiceBatchId: item._id,
            gstInvoiceFinishGoodsId: item.gstInvoiceFinishGoodsId,
            qty: item.qty,
            free: item.free,
        }
        this.despatchServices.deleteItemFromDBById(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                this.getGSTInvoiceFinishGoodsById(item.gstInvoiceFinishGoodsId, 'FromDelete')
                this.SwalServices.Success(response.Message);
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    deleteInvoiceById = (id) => {
        this.SwalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Are you sure you want to delete this invoice?`
        ).then((response) => {
            if (response === true) {
                this.despatchServices.deleteInvoiceById(id).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.getAllGSTInvoiceFinishGoodsRecords()
                        this.SwalServices.Success(response.Message);
                    } else {
                        this.SwalServices.Error(response.Message);
                    }
                });
            }
        });
    }

    generateGSTInvoiceForFinishGoodsById = () => {
        this.SwalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Do you want to print delivery challan ?`
        ).then((response) => {
            this.setState({ isLoading: "print" }, () => {
                let loginUser = getAuthProps();
                let headers = {
                    Authorization: `Bearer ${loginUser.token}`,
                    dbYear: loginUser.dbYear
                };
                if (response === true) {
                    let id = this.state.invoiceDetails.gstInvoiceFinishGoodsId
                    let encryptId = encryptionAPI(id, 0)
                    let deliveryChallan = encryptionAPI(true, 0)
                    // window.open(APIURL + GenerateGSTInvoiceForFinishGoodsById + '?id=' + encryptId + '&id1=' + deliveryChallan, '_blank', { headers });
                    fetch(`${APIURL + GenerateGSTInvoiceForFinishGoodsById}?id=${encryptId}&id1=${deliveryChallan}`, {
                        method: 'GET',
                        headers: headers
                    })
                        .then(response => response.blob())
                        .then(blob => {
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.target = '_blank';
                            link.click();
                            this.setState({ isLoading: "" })
                        })

                } else {
                    let id = this.state.invoiceDetails.gstInvoiceFinishGoodsId
                    let encryptId = encryptionAPI(id, 0)
                    let deliveryChallan = encryptionAPI(false, 0)
                    // window.open(APIURL + GenerateGSTInvoiceForFinishGoodsById + '?id=' + encryptId + '&id1=' + deliveryChallan, '_blank', { headers });
                    fetch(`${APIURL + GenerateGSTInvoiceForFinishGoodsById}?id=${encryptId}&id1=${deliveryChallan}`, {
                        method: 'GET',
                        headers: headers
                    })
                        .then(response => response.blob())
                        .then(blob => {
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.href = url;
                            link.target = '_blank';
                            link.click();
                            this.setState({ isLoading: "" })
                        })
                }
            })
        });


    }

    sendGSTInvoiceFinishGoodsToClient = () => {
        this.SwalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Are you sure you want to send email ?`
        ).then((response) => {
            if (response === true) {
                this.setState({ isLoading: "email" }, () => {
                    let id = this.state.invoiceDetails.gstInvoiceFinishGoodsId
                    this.despatchServices.sendGSTInvoiceFinishGoodsToClient(id).then((response) => {
                        if (response.statusCode === 200 && response.responseData != null) {
                            this.SwalServices.Success(response.Message);
                            this.setState({ isLoading: "" })
                            this.getAllGSTInvoiceFinishGoodsRecords()
                        } else if (response.statusCode === 404) {
                            this.SwalServices.Alert(response.Message);
                            this.setState({ isLoading: "" })
                        } else {
                            this.SwalServices.Error(response.Message);
                            this.setState({ isLoading: "" })
                        }
                    });
                })
            }
        });
    }

    handleChangeForDatePicker = (date, name) => {
        let details = this.state.itemDetails;
        details[name] = date;
        this.setState({ itemDetails: details });
    }

    render() {
        return (
            <>
                <div className="GSTInvoiceFinishGoods-page">
                    {/* First page  */}
                    {this.state.isGridView === true ? (
                        <PartyMainSearchTable
                            filterDetails={this.state.filterDetails}
                            arrangedByList={this.state.arrangedByList}
                            handleDropDownChange={this.handleDropDownChange.bind(this)}
                            handleChange={this.handleChange.bind(this)}
                            closeGridView={this.closeGridView.bind(this)}
                            getGSTInvoiceFinishGoodsInvoiceNo={this.getGSTInvoiceFinishGoodsInvoiceNo.bind(this)}
                            gstInvoiceFinishGoodsList={this.state.gstInvoiceFinishGoodsList}
                            getGSTInvoiceFinishGoodsById={this.getGSTInvoiceFinishGoodsById.bind(this)}
                            deleteInvoiceById={this.deleteInvoiceById.bind(this)}
                            tableStatus={this.state.tableStatus}
                        />
                    ) : null}

                    {/* Second page  */}
                    {this.state.isGridView === false ? (

                        <div className="item-listing">
                            {/* 1. Item Form  */}
                            <ItemForm1
                                invoiceDetails={this.state.invoiceDetails}
                                handleChange={this.handleChange.bind(this)}
                                setFilterParameters={this.setFilterParameters.bind(this)}
                                partyDropdownList={this.state.partyDropdownList}
                                transportCourierList={this.state.transportCourierList}
                                validStateForPartyDetails={this.state.validStateForPartyDetails}
                            />

                            {/* 2.  Item tabel  */}
                            <ItemTable
                                itemListing={this.state.itemListing}
                                openPopUpForAddingItem={this.openPopUpForAddingItem.bind(this)}
                                isHideAddItem={this.state.isHideAddItem}
                                hsnCodeList={this.state.hsnCodeList}
                                editItemDetails={this.editItemDetails.bind(this)}
                                deleteItemById={this.deleteItemById.bind(this)}
                                deleteItemFromDBById={this.deleteItemFromDBById.bind(this)}
                            />

                            {/* 3. Table & Sections  */}
                            <div className="flex  gap-3 mb-4">
                                <HSNCodeTable
                                    hsnCodeListForTable={this.state.hsnCodeListForTable}
                                />
                                <PaymentSummary
                                    invoiceDetails={this.state.invoiceDetails}
                                    page={this.state.page}
                                />
                            </div>

                            <hr />
                            {/* 4. Item Form 2   */}
                            <ItemForm2
                                invoiceDetails={this.state.invoiceDetails}
                                handleChange={this.handleChange.bind(this)}
                                page={this.state.page}
                                handleChangeCheckBox={this.handleChangeCheckBox.bind(this)}
                            />

                            <div className="btn-grp flex gap-2.5 mt-3.5">

                                <button
                                    className="add-btn"
                                    disabled={this.state.isLoading}
                                    onClick={() => this.addEditGSTInvoiceFinishGoods()}
                                >
                                    {this.state.isLoading === "save" ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                                </button>
                                {this.state.invoiceDetails.gstInvoiceFinishGoodsId !== '' ?
                                    <>
                                        <button
                                            className="print-btn"
                                            disabled={this.state.isLoading}
                                            onClick={() => this.generateGSTInvoiceForFinishGoodsById()}

                                        >
                                            {this.state.isLoading === "print" ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Print"}
                                        </button>
                                        <button
                                            className="search-btn"
                                            disabled={this.state.isLoading}
                                            onClick={() => this.sendGSTInvoiceFinishGoodsToClient()}
                                        >
                                            {this.state.isLoading === "email" ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Party E-Mail"}
                                        </button>
                                    </>
                                    : null}

                                <button
                                    className="cancel-btn"
                                    disabled={this.state.isLoading}
                                    onClick={() => this.openGridView()}
                                >
                                    Cancel
                                </button>
                            </div>


                        </div>
                    ) : null}
                </div>

                <ItemDetailsModel
                    setItemDetailsModel={this.state.setItemDetailsModel}
                    setOpenModel={this.setOpenModel.bind(this)}
                    hsnCodeList={this.state.hsnCodeList}
                    companyItemList={this.state.companyItemList}
                    setFilterParametersForItemTable={this.setFilterParametersForItemTable.bind(this)}
                    handleChangeForItemTable={this.handleChangeForItemTable.bind(this)}
                    itemDetails={this.state.itemDetails}
                    productionStockList={this.state.productionStockList}
                    selectQtyFromStock={this.selectQtyFromStock.bind(this)}
                    validationTextForStock={this.state.validationTextForStock}
                    validateStockQty={this.validateStockQty.bind(this)}
                    isEditing={this.state.isEditing}
                    addItemToItemArray={this.addItemToItemArray.bind(this)}
                    validState={this.state.validState}
                    closePopUp={this.closePopUp.bind(this)}
                    page={this.state.page}
                    handleChangeForDatePicker={this.handleChangeForDatePicker.bind(this)}
                />
            </>
        );
    }
}

export default GSTInvoiceFinishGoods;